import { NgModule } from "@angular/core";
import {
    ExtraOptions,
    PreloadAllModules,
    RouterModule,
} from "@angular/router";
import { appRoutes } from "./app-routes";

const config: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
    initialNavigation: 'enabledBlocking',
};

@NgModule({
    imports: [RouterModule.forRoot(appRoutes, config)],
    exports: [RouterModule],
})
export class AppRoutingModule { }